// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"d850ff16","316":"5399f89b","439":"4a7349a2","487":"23718041","557":"f480491e","705":"2b8baaa3","945":"b47952e4","953":"4ff06602","987":"9e454a41"}[chunkId] + ".chunk.js";
};